import { ROUTE } from 'constant';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import Shared from 'screens/shared';
import { createForm } from './config';

export default () => {
  let { [ACTIONS_TYPES.CERTIFICATE_MANAGER.GET_ALL]: certificates = [] } = useSelector((e) => e);
  certificates = certificates.map(({ id, properties = {} }) => ({ id, ...properties }));

  useEffect(() => {
    actions.certificateManager.getAll();
  }, []);

  const addHandler = (properties) => {
    actions.certificateManager.create({ properties });
  };

  const deleteHandler = ({ id }) => {
    actions.certificateManager.delete({ id });
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.CERTIFICATE_MANAGER}
      isStrap={false}
    >
      <Shared.widgets.Section
        sectionTitle="Certificates"
        createForm={{
          ...createForm,
          onSubmit: addHandler,
        }}
        items={certificates}
        itemIcon={ROUTE.DASHBOARD.CERTIFICATE_MANAGER.icon}
        setItemTitle={(e) => e.name}
        itemOnDelete={deleteHandler}
        createActionType={ACTIONS_TYPES.CERTIFICATE_MANAGER.CREATE}
        setItemKey={(e) => e.id}
        tableColumns={['', 'Name', '', 'Actions']}
      />
    </Shared.widgets.Page>
  );
};
